import { get } from './common/Helper';

export const getFolderNames = async(token) => {
    let url = "https://contentprocess.tosanalytics.com/api/mediafile/foldernames"
    return await get(url, token);
};
